import { EditoriaTheme } from '@/shared/types/home.types';
import classNames from '@/utils/className';

interface EditorialSectionLogoProps {
  editoria: EditoriaTheme;
  isFeatured?: boolean;
}

/**
 * Header de identidade da editoria nas seções de home/listagem: a logo da
 * editoria (data-driven, do Directus) centralizada sobre a caixa já colorida
 * pela cor de marca. Substitui o header hardcoded por marca
 * (`EditorialCategorySponsorBanner`). Sem logo → não renderiza nada.
 */
export default function EditorialSectionLogo({ editoria, isFeatured = false }: EditorialSectionLogoProps) {
  const logoUrl = editoria.logo?.url;

  if (!logoUrl) return null;

  return (
    <div className={classNames('flex items-center justify-center', isFeatured ? 'py-4' : 'p-4')}>
      <a href={`/${editoria.slug}/`} title={editoria.nome} className="flex items-center [&>img]:h-8">
        <img src={logoUrl} alt={editoria.nome} className="h-8 w-auto object-contain" />
      </a>
    </div>
  );
}
